import { Component, OnInit } from '@angular/core';
import { PagosService } from 'src/app/services/pagos/pagos.service';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
import {FormsModule} from '@angular/forms';
import { Postulaciones } from '../../models/postulaciones/postulaciones.model';

@Component({
  selector: 'app-pagos',  
  templateUrl: '../../pages/pagos/pagos.component.html',
  styleUrls: ['../../pages/pagos/pagos.component.css']
})
export class PagosComponent implements OnInit 
{
    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")

    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
  
    postulaciones: any = []

  
    productos: any = []
    idProducto: any = 1
    totalizado: any = 0
    fechaPagoGrupo: any
    fechaContable: any
    agrupadorProductos: any = []
    currentDate: any
  
    
    allComplete: boolean = false

    constructor(private pagosService: PagosService, private postulacionesService: PostulacionesService,
                private dialog: MatDialog, private productosService: ProductosService) { }

    ngOnInit(): void 
    {
        let vm = this
        this.currentDate    = new Date(Date.now()).getTime();
      
        this.productosService.obtieneProductos().then ( productos => vm.productos = productos )        
        .catch ( error => console.log(error) )
        this.productosService.obtieneAgrupadorProductos().then ( agrupadorProductos => vm.agrupadorProductos = agrupadorProductos )        
        .catch ( error => console.log(error) )

        this.loadData()
    }

    loadData()
    {
        let vm = this
    
        vm.allComplete=false;      
        vm.postulaciones = [] 
        this.totalizado=0;
        this.total=0;
        this.pagosService.traePostulaciones(this.idProducto).then
        (
            (postulaciones: any) =>
            { 
                postulaciones.forEach(postulacion => { postulacion.seleccionado = false })
                vm.postulaciones = postulaciones
                vm.config.totalItems = postulaciones.length
            }
        )
        .catch 
        ( 
            error => 
            {
                console.log(error)

                if(error.status == 404)
                {
                    this.openAlertDialog("No hay registros disponibles para pago con el producto seleccionado", "btn-danger")
                }
            }
        )
    }
    
    someComplete(): boolean 
    {   
      
        if (this.postulaciones.seleccionado == null) { return false }

        return this.postulaciones.filter(p => p.seleccionado).length > 0 && !this.allComplete
    }
    
    setAll(seleccionado: boolean) 
    {
        this.allComplete = seleccionado
        
        if (this.postulaciones == null) { return }       
     //   this.total=0;
        for(let i = this.config.indexInicial; i < this.config.indexMaximo; i++)
        {         
            if(this.postulaciones[i]){
                this.postulaciones[i] ? this.postulaciones[i].seleccionado = seleccionado : null
                  if(seleccionado)
                      this.total+=this.postulaciones[i].montoReembolso;
                  else
                      this.total-=this.postulaciones[i].montoReembolso;
            }
         
        }
        this.totalizado= this.total;
    }

    updateAllComplete() 
    {        
        this.allComplete =  this.postulaciones != null && this.postulaciones
                            .slice(this.config.indexInicial, this.config.indexMaximo)
                            .every(p => p.seleccionado)
    }
    total = 0;
    actualizaTotal(postulacion) {       
        if(postulacion.seleccionado) {
          this.total += postulacion.montoReembolso;
        } else {
          this.total -= postulacion.montoReembolso;
        }
        if(isNaN(this.total)){
            this.total=0;
        } 
        this.totalizado=this.total;
    }


    enviarPostulacionesSeleccionadas()
    {
        let postulacionesSeleccionadas: [] = this.postulaciones.filter( pos => pos.seleccionado )
        let fechaPago = this.fechaPagoGrupo
        let fechaContable = this.fechaContable
        let idUsuario = localStorage.getItem("idUsuario")

        if(postulacionesSeleccionadas.length == 0)
        {
            this.openAlertDialog("Debe seleccionar al menos una postulación.", "btn-danger")
            return
        }

        if(isNullOrUndefined(fechaPago))
        {
            this.openAlertDialog("Debe seleccionar una fecha de pago.", "btn-danger")
            return
        }
        else 
        { 
            fechaPago = this.fechaPagoGrupo.split('-')[2] + '-' + this.fechaPagoGrupo.split('-')[1] + '-' + this.fechaPagoGrupo.split('-')[0]
        }

        if(isNullOrUndefined(fechaContable))
        {
            this.openAlertDialog("Debe seleccionar una fecha Contable.", "btn-danger")
            return
        }
        else 
        { 
            fechaContable = this.fechaContable.split('-')[2] + '-' + this.fechaContable.split('-')[1] + '-' + this.fechaContable.split('-')[0]
        }

       
        let fechaInicio = new Date( fechaPago.split('-')[2] + '-' +
        fechaPago.split('-')[1] + '-' +
        fechaPago.split('-')[0]+'T24:00').getTime();   

     
        let fechaActual    = new Date(Date.now()).getTime();

        if(fechaInicio < fechaActual )
        {
            this.openAlertDialog("La fecha seleccionada no debe ser menos a la fecha actual.", "btn-danger")
            return
        }

        let vm = this

        let postulacionesSimplificadas= this.simplificaPostulacion(postulacionesSeleccionadas)
  
        this.pagosService.creaGrupoPago(fechaPago,fechaContable, idUsuario, postulacionesSimplificadas).then
        (
            () => 
            {
                vm.openAlertDialog("La agrupación de pago ha sido generada, en los próximos minutos estará disponible", "btn-success")
                vm.loadData()
            }
        )
        .catch
        (
            error => 
            {
                console.log(error)

                vm.openAlertDialog("Ha ocurrido un error al generar la agrupación de pago.", "btn-danger")
            }
        )
    }

    verArchivo(postulacionId: any)
    {
        let vm = this
    
        this.postulacionesService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`             
                    window.open(fileURL);
                })  
               
            }
        )
        .catch 
        ( 
            error =>  
            {
                console.log(error)

                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )        
    }

    openAlertDialog(mensaje: string, clase: string)  
    {
        const dialogRef = this.dialog.open(AlertDialogComponent, 
        {
            data: 
            {              
                message: mensaje,
                clase: clase,
                buttonText: { cancel: 'Listo!' },
            }
        })
    }

    pageChanged(event: any) 
    { 
        this.config.currentPage = event 
        
        this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )

        this.updateAllComplete()
    }

    cambiaCantidadRegistros()
    {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1 
    }

    simplificaPostulacion(postulacion) {  
    var postulaciones2:Postulaciones []= new Array()  ;  
        for (var i = 0; i < postulacion.length; i++) {
                postulaciones2.push({ id: postulacion[i].id, nombreProducto: postulacion[i].nombreProducto,nombreTipoProducto: postulacion[i].categoriaProducto,idCarga: postulacion[i].idCarga } );
        }
    return postulaciones2;
    }
}